import styled from 'styled-components'
import { Trans } from 'react-i18next'
import moment from 'moment'
import { colors, fontWeights } from '@/styles'

const TopProgressBar = styled.div`
  width: 100%;
  height: 48px;
  background-color: #27567d;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.white};
  font-size: 14px;
  line-height: 16px;
  font-weight: ${fontWeights.medium};
  padding: 0 24px;
  position: sticky;
  top: 53px;
  z-index: 10;
  min-height: 48px;
`

const HasSignedComponent = ({ currentSigner }) => {
  const userName = `${currentSigner?.first_name} ${currentSigner?.last_name}`
  const signedAt = currentSigner?.signed_at
    ? `${moment(currentSigner?.signed_at).format('MMM. Do, YYYY')} at ${moment(
        currentSigner?.signed_at
      ).format('h:mm a')}`
    : ''

  return (
    <TopProgressBar>
      <div>
        <Trans
          i18nKey="l.contract_edit.document_widget.this_contract_signed_1.label"
          userName={userName}
          signedAt={signedAt}
        >
          This document was signed by {{ userName }} on {{ signedAt }}.
        </Trans>
      </div>
    </TopProgressBar>
  )
}

export default HasSignedComponent
